export const iconFontAwesomeMediaplaybackCirclePause = (
	<i className="fa-solid fa-circle-pause"></i>
);
